import React, { useState, useEffect, useRef } from "react";
import { downloadCsv } from "../common/sharedFunctions";
import MaterialTable from "material-table";
import { useSelector, useDispatch } from "react-redux";
import CircularLoading from "../components/CircularLoading";
import { api } from "common";
import { useTranslation } from "react-i18next";
import moment from "moment/min/moment-with-locales";
import { colors } from "../components/Theme/WebTheme";
import "../styles/style.css";
import * as yup from "yup";
import { Modal, Button, TextField } from "@mui/material";

export default function Users() {
  const { t, i18n } = useTranslation();
  const isRTL = i18n.dir();
  const settings = useSelector((state) => state.settingsdata.settings);
  const { addUser, editUser, deleteUser, checkUserExists, fetchUsersOnce } =
    api;
  const [data, setData] = useState([]);
  const staticusers = useSelector((state) => state.usersdata.staticusers);
  const dispatch = useDispatch();
  const loaded = useRef(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [editing, setediting] = useState(false);
  const [oldData, setOlddata] = useState("");
  useEffect(() => {
    dispatch(fetchUsersOnce());
  }, [dispatch, fetchUsersOnce]);

  useEffect(() => {
    if (staticusers) {
      setData(staticusers.filter((user) => user.usertype === "fleetadmin"));
    } else {
      setData([]);
    }
    loaded.current = true;
  }, [staticusers]);
  const handleOpenModal = () => {
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
  };

  const handleAddrow = (newData) => {
    console.log(newData, "ggg");
    new Promise((resolve, reject) => {
      setTimeout(() => {
        checkUserExists(newData).then((res) => {
          if (res.users && res.users.length > 0) {
            alert(t("user_exists"));
            reject();
          } else if (!(newData && newData.firstName)) {
            alert(t("proper_input_name"));
            reject();
          } else if (res.error) {
            alert(t("email_or_mobile_issue"));
            reject();
          } else {
            newData["usertype"] = "fleetadmin";
            newData["createdAt"] = new Date().getTime();
            delete newData.tableData;
            dispatch(addUser(newData));
            dispatch(fetchUsersOnce());
            resolve();
          }
        });
      }, 600);
    });
  };
  const handleUpdateRow = (newData, oldData) => {
    new Promise((resolve, reject) => {
      setTimeout(() => {
        if (!(newData && newData.firstName)) {
          alert(t("proper_input_name"));
          reject();
        } else {
          resolve();
          if (newData !== oldData) {
            delete newData.tableData;
            dispatch(editUser(oldData.id, newData));
            dispatch(fetchUsersOnce());
          }
        }
      }, 600);
    });
  };
  const columns = [
    {
      title: t("createdAt"),
      field: "createdAt",
      editable: "never",
      defaultSort: "desc",
      render: (rowData) =>
        rowData.createdAt ? moment(rowData.createdAt).format("lll") : null,
      exportTransformer: (rowData) =>
        new Date(rowData.createdAt).toLocaleDateString() +
        " " +
        new Date(rowData.createdAt).toLocaleTimeString(),
    },
    {
      title: t("first_name"),
      field: "firstName",
      initialEditValue: "",
      cellStyle: { paddingLeft: isRTL === "rtl" ? 50 : 15 },
    },
    {
      title: t("last_name"),
      field: "lastName",
      initialEditValue: "",
      cellStyle: { paddingLeft: isRTL === "rtl" ? 30 : 15 },
    },
    {
      title: t("mobile"),
      field: "mobile",
      editable: "onAdd",
      render: (rowData) =>
        settings.AllowCriticalEditsAdmin ? rowData.mobile : "Hidden for Demo",
    },
    {
      title: t("email"),
      field: "email",
      editable: "onAdd",
      render: (rowData) =>
        settings.AllowCriticalEditsAdmin ? rowData.email : "Hidden for Demo",
      headerStyle: { textAlign: "center" },
    },
    {
      title: t("profile_image"),
      field: "profile_image",
      render: (rowData) =>
        rowData.profile_image ? (
          <img
            alt="Profile"
            src={rowData.profile_image}
            style={{ width: 50, borderRadius: "50%" }}
          />
        ) : null,
      editable: "never",
      cellStyle: { textAlign: isRTL === "rtl" ? "right" : "center" },
    },
    {
      title: t("account_approve"),
      field: "approved",
      type: "boolean",
      initialEditValue: true,
      cellStyle: { textAlign: "center" },
    },
  ];

  const [selectedRow, setSelectedRow] = useState(null);

  return !loaded.current ? (
    <CircularLoading />
  ) : (
    <>
      <MaterialTable
        //title={t("fleetadmins")}
        title={<span className="tableTitleStyle">{t("fleetadmins")}</span>}
        columns={columns}
        style={{
          direction: isRTL === "rtl" ? "rtl" : "ltr",
          borderRadius: "20px",
          // marginTop: 30,
          boxShadow: "rgba(0, 0, 0, 0.1) 0px -0.4rem 3rem",
        }}
        data={data}
        onRowClick={(evt, selectedRow) =>
          setSelectedRow(selectedRow.tableData.id)
        }
        options={{
          exportCsv: (columns, data) => {
            let hArray = [];
            const headerRow = columns.map((col) => {
              if (typeof col.title === "object") {
                return col.title.props.text;
              }
              hArray.push(col.field);
              return col.title;
            });
            const dataRows = data.map(({ tableData, ...row }) => {
              row.createdAt =
                new Date(row.createdAt).toLocaleDateString() +
                " " +
                new Date(row.createdAt).toLocaleTimeString();
              let dArr = [];
              for (let i = 0; i < hArray.length; i++) {
                dArr.push(row[hArray[i]]);
              }
              return Object.values(dArr);
            });
            const { exportDelimiter } = ",";
            const delimiter = exportDelimiter ? exportDelimiter : ",";
            const csvContent = [headerRow, ...dataRows]
              .map((e) => e.join(delimiter))
              .join("\n");
            const csvFileName = "download.csv";
            downloadCsv(csvContent, csvFileName);
          },
          exportButton: {
            csv: settings.AllowCriticalEditsAdmin,
            pdf: false,
          },
          maxColumnSort: "all_columns",
          rowStyle: (rowData) => ({
            fontSize: "12px",
            // backgroundColor:
            //   selectedRow === rowData.tableData.id ? "#EEE" : "#FFF",
          }),
          editable: {
            fontSize: "12px",
            fontWeight: "bold ",
            // backgroundColor: colors.Header_Text,
            // fontSize: "0.8em",
            // fontWeight: "bold ",
            // fontFamily: 'Lucida Console", "Courier New", monospace',
          },
          headerStyle: {
            position: "sticky",
            top: "0px",
            //backgroundColor: colors.Header_Text_back,
            backgroundColor: "#e1e7f0",
            color: "#000",
            fontSize: "12px",
            fontWeight: "bold ",
            //fontFamily: 'Lucida Console", "Courier New", monospace',
          },
        }}
        localization={{
          body: {
            addTooltip: t("add"),
            deleteTooltip: t("delete"),
            editTooltip: t("edit"),
            emptyDataSourceMessage: t("blank_message"),
            editRow: {
              deleteText: t("delete_message"),
              cancelTooltip: t("cancel"),
              saveTooltip: t("save"),
            },
          },
          toolbar: {
            searchPlaceholder: t("search"),
            exportTitle: t("export"),
          },
          header: {
            actions: t("actions"),
          },
          pagination: {
            labelDisplayedRows: "{from}-{to} " + t("of") + " {count}",
            firstTooltip: t("first_page_tooltip"),
            previousTooltip: t("previous_page_tooltip"),
            nextTooltip: t("next_page_tooltip"),
            lastTooltip: t("last_page_tooltip"),
          },
        }}
        actions={[
          {
            icon: "edit",
            onClick: (event, rowData) => {
              // Do save operation
              setediting(true);
              setOlddata(rowData);
              handleOpenModal();
            },
          },
          {
            icon: "add",
            tooltip: "Add Row",
            isFreeAction: true,
            onClick: handleOpenModal,
          },
        ]}
        editable={{
          // onRowAdd: (newData) =>
          //   new Promise((resolve, reject) => {
          //     setTimeout(() => {
          //       checkUserExists(newData).then((res) => {
          //         if (res.users && res.users.length > 0) {
          //           alert(t("user_exists"));
          //           reject();
          //         } else if (!(newData && newData.firstName)) {
          //           alert(t("proper_input_name"));
          //           reject();
          //         } else if (res.error) {
          //           alert(t("email_or_mobile_issue"));
          //           reject();
          //         } else {
          //           newData["usertype"] = "fleetadmin";
          //           newData["createdAt"] = new Date().getTime();
          //           delete newData.tableData;
          //           dispatch(addUser(newData));
          //           dispatch(fetchUsersOnce());
          //           resolve();
          //         }
          //       });
          //     }, 600);
          //   }),
          // onRowUpdate: (newData, oldData) =>
          //   new Promise((resolve, reject) => {
          //     setTimeout(() => {
          //       if (!(newData && newData.firstName)) {
          //         alert(t("proper_input_name"));
          //         reject();
          //       } else {
          //         resolve();
          //         if (newData !== oldData) {
          //           delete newData.tableData;
          //           dispatch(editUser(oldData.id, newData));
          //           dispatch(fetchUsersOnce());
          //         }
          //       }
          //     }, 600);
          //   }),
          onRowDelete: (oldData) =>
            settings.AllowCriticalEditsAdmin
              ? new Promise((resolve) => {
                  setTimeout(() => {
                    resolve();
                    dispatch(deleteUser(oldData.id));
                    dispatch(fetchUsersOnce());
                  }, 600);
                })
              : new Promise((resolve) => {
                  setTimeout(() => {
                    resolve();
                    alert(t("demo_mode"));
                  }, 600);
                }),
        }}
      />
      <AddAdminModal
        open={modalOpen}
        onClose={handleCloseModal}
        handleAddrow={handleAddrow}
        oldData={oldData}
        editing={editing}
        setediting={setediting}
        handleUpdateRow={handleUpdateRow}
        setOlddata={setOlddata}
      />
    </>
  );
}

const AddAdminModal = ({
  open,
  onClose,
  handleAddrow,
  editing,
  oldData,
  setediting,
  handleUpdateRow,
  setOlddata,
}) => {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [email, setEmail] = useState("");
  const [errors, setErrors] = useState({});

  const schema = yup.object().shape({
    firstName: yup.string().required("First Name is required"),
    lastName: yup.string().required("Last Name is required"),
    mobileNumber: yup.string().required("Mobile Number is required"),
    // .matches(/^\d{10}$/, "Mobile Number must be a 10-digit number"),
    email: yup.string().required("Email is required").email("Invalid Email"),
  });

  const validateForm = async () => {
    try {
      await schema.validate(
        { firstName, lastName, mobileNumber, email },
        { abortEarly: false }
      );
      setErrors({});
      return true;
    } catch (validationErrors) {
      const errorsMap = {};
      validationErrors.inner.forEach((error) => {
        errorsMap[error.path] = error.message;
      });
      setErrors(errorsMap);
      return false;
    }
  };
  useEffect(() => {
    if (oldData) {
      console.log(oldData, "oldDataCHK");
      setFirstName(oldData?.firstName);
      setLastName(oldData?.lastName);
      setMobileNumber(oldData?.mobile);
      setEmail(oldData?.email);
    }
  }, [oldData]);

  const handleAddAdmin = async () => {
    const isValid = await validateForm();
    if (!isValid) return;

    // Perform your logic to add the admin here
    let paramdata = {
      firstName: firstName,
      lastName: lastName,
      mobile: mobileNumber,
      email: email,
    };

    let oldObjectKeys = Object.keys(oldData);
    let newObjectkeys = Object.keys(paramdata);
    let commonKeys = getCommonElements(oldObjectKeys, newObjectkeys);
    commonKeys.forEach((val) => {
      delete oldData[val];
    });

    const latestObj = { ...oldData, ...paramdata };
    if (editing) {
      handleUpdateRow(latestObj, oldData);
    } else {
      handleAddrow(paramdata);
    }
    setediting(false);
    // Reset the form
    setFirstName("");
    setLastName("");
    setMobileNumber("");
    setEmail("");

    // Close the modal
    onClose();
  };

  const handleClose = () => {
    // Reset the form
    setFirstName("");
    setLastName("");
    setMobileNumber("");
    setEmail("");
    setediting(false);
    setErrors("");
    setOlddata("");
    // Close the modal
    onClose();
  };

  function getCommonElements(array1, array2) {
    return array1.filter((element) => array2.includes(element));
  }
  return (
    <Modal open={open} onClose={handleClose}>
      <div
        className="modal-container"
        style={{
          backgroundColor: "white",
          width: "80%",
          margin: "auto",
          marginTop: "10vh",
          padding: "20px",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <h2>{editing ? "Edit" : "Add"} Fleet Admin</h2>
        <TextField
          label="First Name"
          value={firstName}
          onChange={(e) => setFirstName(e.target.value)}
          error={errors.firstName !== undefined}
          helperText={errors.firstName}
          required
          style={{ width: "100%", marginBottom: "10px" }}
        />
        <TextField
          label="Last Name"
          value={lastName}
          onChange={(e) => setLastName(e.target.value)}
          error={errors.lastName !== undefined}
          helperText={errors.lastName}
          required
          style={{ width: "100%", marginBottom: "10px" }}
        />
        <TextField
          label="Mobile Number"
          value={mobileNumber}
          placeholder="+15555551234"

          // disabled={editing}
          onChange={(e) => setMobileNumber(e.target.value)}
          error={errors.mobileNumber !== undefined}
          helperText={errors.mobileNumber}
          required
          style={{ width: "100%", marginBottom: "10px" }}
        />
        <TextField
          label="Email (Username)"
          value={email}
          disabled={editing}
          onChange={(e) => setEmail(e.target.value)}
          error={errors.email !== undefined}
          helperText={errors.email}
          required
          style={{ width: "100%", marginBottom: "10px" }}
        />
        <div className="button-container" style={{ marginTop: "20px" }}>
          <Button
            variant="contained"
            onClick={handleAddAdmin}
            style={{ backgroundColor: "darkblue", color: "white" }}
          >
            {editing ? "Update" : "Add"}
          </Button>
          <Button
            variant="contained"
            color="secondary"
            onClick={handleClose}
            style={{
              backgroundColor: "darkblue",
              color: "white",
              marginLeft: "10px",
            }}
          >
            Cancel
          </Button>
        </div>
      </div>
    </Modal>
  );
};
